import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { HttpService } from '../http/http.service';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardGuard implements CanActivate {
  constructor(private router: Router,
   private httpService: HttpService,
   private utilityService : UtilityService) {}

  canActivate() : boolean {
    if(this.httpService.loggedIn()){
      return true
    }else{
      this.utilityService.openSnackBar('Login first to open dashboard');
      this.router.navigate(['/admin/login']);
      return false;
    }
  }
}
